<template>
  <div>
    <aw-spring :desktop-size="10">
      <aw-breadcrumb-version2 id="cms_breadcrumb" />
      <div :ref="Navigation[ID_CMS]" />
    </aw-spring>
    <aw-cms-page :content-data="contentData" :class="$style.content" />
  </div>
</template>
<script>
  import { defineAsyncComponent } from 'vue';
  import { mapState } from 'pinia';
  import { useRuntimeConfig, useRoute, defineNuxtComponent, useHead } from 'nuxt/app';
  import AwBreadcrumbVersion2 from '~~/common/components/Common/AwBreadcrumbVersion2';
  import { Navigation, ID_CMS, focusRef } from '~~/common/config/Navigation.js';
  import AwSpring from '~~/common/components/AwSpring.vue';
  import { useContentsStore } from '~~/common/stores/contents';
  import { useUserInterfaceStore } from '~~/common/stores/userInterface';

  export default defineNuxtComponent({
    name: 'ContentPage',
    components: {
      AwSpring,
      AwCmsPage: defineAsyncComponent(() => import('~~/common/components/Page/Content/AwCmsPage')),
      AwBreadcrumbVersion2,
    },
    data () {
      return {
        Navigation,
        ID_CMS,
      };
    },
    head () {
      const config = useRuntimeConfig();

      const scriptTag = [];
      if (config.public.acquireEnabled) {
        scriptTag.push({
          innerHTML: '(function(){var script=`https://s.acquire.io/a-f7346/init.js?full`; var x=document.createElement(`script`);x.src=script;x.async=true;var sx=document.getElementsByTagName(`script`)[0]; sx.parentNode.insertBefore(x, sx);})()',
        });
      }
      useHead({
        script: scriptTag,
      });
    },
    computed: {
      ...mapState(useContentsStore, {
        contentData: state => state.data,
      }),
    },
    mounted () {
      const route = useRoute();
      useUserInterfaceStore().setBackground({ ...this.contentData });

      if (!route.hash) {
        focusRef(this, { refId: Navigation[ID_CMS] });
      }
    },

  });
</script>

<style module lang="scss" rel="stylesheet/scss">
.content {
  margin-top: 24px;
  padding-bottom: 20px;

  @include tablet(min) {
    padding-bottom: 40px;
  }
}
</style>
